const faqs = [
  {
    q: '91免费视频网站需要注册才能观看吗？',
    a: '无需注册，91免费视频网站所有国产免费视频资源均可直接在线观看，打开即播，为您提供最便捷的观影体验。我们致力于让每一位观众都能零门槛享受91国产免费视频与91传媒视频在线内容。',
  },
  {
    q: '视频播放卡顿或缓冲怎么办？',
    a: '91免费视频网站全线采用CDN加速技术，正常情况下高清视频流畅不缓冲。如遇卡顿，建议检查网络连接状态，或尝试切换清晰度选项。我们持续优化播放体验，确保91国产视频在线观看流畅。',
  },
  {
    q: '网站支持哪些设备观看？',
    a: '91免费视频网站全面适配电脑、平板和手机浏览器，无论是Windows、macOS、Android还是iOS系统，均可直接打开网站观看国产视频在线观看免费内容，无需安装任何软件或插件。',
  },
  {
    q: '视频资源多久更新一次？',
    a: '编辑团队每日更新50部以上国产影片，涵盖91国产免费视频、91国产小视频、91传媒视频在线等多种类型。您可以在"每日更新"专区查看最新入库的影片资源，确保内容始终新鲜。',
  },
  {
    q: '如何向我们投稿或合作？',
    a: '优质国产视频创作者可通过投稿邮箱 tougao@91freevideo.com 联系我们，商务合作请发送至 hezuo@91freevideo.com。91免费视频网站为优秀创作者提供海量曝光机会，期待与您携手为广大观众呈现更多精彩内容。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-[560px] mx-auto">
            关于91免费视频网站的使用、资源更新与合作的常见疑问解答
          </p>
        </div>

        <div className="max-w-[800px] mx-auto flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-100 border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}